import React, { useState, useEffect } from 'react';
import client from '../../api/client';
import AdminLayout from '../../components/AdminLayout';
import Button from '../../components/Button';
import Alert from '../../components/Alert';

const FIELDS = [
  { key: 'position',          label: '岗位' },
  { key: 'company',           label: '公司名称' },
  { key: 'industry',          label: '所属行业' },
  { key: 'work_years',        label: '工作年限' },
  { key: 'ai_usage_freq',     label: 'AI 使用频率' },
  { key: 'ai_usage_purpose',  label: 'AI 使用目的' },
  { key: 'job_category',      label: '岗位类别' },
  { key: 'job_line',          label: '业务条线' },
  { key: 'management_level',  label: '管理层级' },
  { key: 'skill_level',       label: 'AI 能力等级' },
];

const STATE_OPTIONS = [
  { value: 'required', label: '必填', color: '#dc2626', bg: '#fef2f2' },
  { value: 'optional', label: '可选', color: '#2d5aa0', bg: '#eff6ff' },
  { value: 'hidden',   label: '隐藏', color: '#94a3b8', bg: '#f8fafc' },
];

export default function AdminEnterpriseFormConfigPage() {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    client.get('/enterprises/form-config/')
      .then(({ data }) => setConfig(data))
      .catch(() => setError('加载失败'))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (key, value) => {
    setConfig(c => ({ ...c, [key]: value }));
  };

  const handleSave = async () => {
    setSaving(true); setError(''); setSuccess('');
    try {
      await client.put('/enterprises/form-config/', config);
      setSuccess('配置已保存');
    } catch (e) {
      setError(e.response?.data?.detail || '保存失败');
    } finally { setSaving(false); }
  };

  return (
    <AdminLayout title="信息收集配置">
      <div style={{ maxWidth: 640 }}>
        {error && <Alert type="error" style={{ marginBottom: 12 }}>{error}</Alert>}
        {success && <Alert type="success" style={{ marginBottom: 12 }}>{success}</Alert>}

        <p style={{ fontSize: 13, color: '#64748b', marginBottom: 20 }}>
          配置企业员工填写基础信息时，各字段的显示状态。设为「隐藏」的字段不会在表单中出现。
        </p>

        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden', marginBottom: 20 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                {['字段', '必填', '可选', '隐藏'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: h === '字段' ? 'left' : 'center', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {FIELDS.map((field, idx) => (
                <tr key={field.key} style={{ borderBottom: idx < FIELDS.length - 1 ? '1px solid #f1f5f9' : 'none' }}>
                  <td style={{ padding: '14px 16px', fontWeight: 500, color: '#1e293b' }}>
                    {field.label}
                    {(field.key === 'company' || field.key === 'industry') && (
                      <span style={{ fontSize: 11, color: '#94a3b8', marginLeft: 6 }}>（企业账号自动填入）</span>
                    )}
                  </td>
                  {STATE_OPTIONS.map(opt => (
                    <td key={opt.value} style={{ padding: '14px 16px', textAlign: 'center' }}>
                      <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <input
                          type="radio"
                          name={field.key}
                          value={opt.value}
                          checked={config[field.key] === opt.value}
                          onChange={() => handleChange(field.key, opt.value)}
                          style={{ accentColor: opt.color, width: 16, height: 16 }}
                        />
                      </label>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* 预览当前状态 */}
        <div style={{ background: '#f8fafc', borderRadius: 10, border: '1px solid #e2e8f0', padding: 16, marginBottom: 20 }}>
          <p style={{ fontSize: 12, fontWeight: 600, color: '#64748b', marginBottom: 10 }}>当前配置预览</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {FIELDS.map(field => {
              const state = config[field.key] || 'optional';
              const opt = STATE_OPTIONS.find(o => o.value === state);
              return (
                <span key={field.key} style={{
                  padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 500,
                  background: opt?.bg, color: opt?.color, border: `1px solid ${opt?.color}30`,
                }}>
                  {field.label}（{opt?.label}）
                </span>
              );
            })}
          </div>
        </div>

        {loading ? (
          <p style={{ color: '#94a3b8', fontSize: 13 }}>加载中...</p>
        ) : (
          <Button onClick={handleSave} disabled={saving}>
            {saving ? '保存中...' : '保存配置'}
          </Button>
        )}
      </div>
    </AdminLayout>
  );
}
